export const formatToISOStartOfDayLocal = (date: string | Date): string => {
    const parsedDate = new Date(date);
    parsedDate.setHours(0, 0, 0, 0);
    return parsedDate.toISOString();
};

export const formatToISOEndOfDayLocal = (date: string | Date): string => {
    const parsedDate = new Date(date);
    parsedDate.setHours(23, 59, 59, 999);
    return parsedDate.toISOString();
};